module.exports = __webpack_public_path__ + "static/media/COMBAT_COLOUR.91df3c24.png";